import { Button, Grid } from "@material-ui/core";
import { GridColDef } from "@material-ui/data-grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";
import { useWorkerTypesContext } from "../../../context/WorkerTypesContext";

type Props = {
	setModalEditDataWorkerType: Function;
	setModalDeleteWorkerType: Function;
	setWorkerTypeIdForEdit: Function;
	setWorkerTypeIdForDelete: Function;
};

export const useTableWorkerTypes = ({
	setModalEditDataWorkerType,
	setModalDeleteWorkerType,
	setWorkerTypeIdForEdit,
	setWorkerTypeIdForDelete,
}: Props) => {
	const {
		state: { workerTypes },
	} = useWorkerTypesContext();

	const columns: GridColDef[] = [
		{
			field: "workerTypeId",
			headerName: " ",
			sortable: true,
			width: 0,
		},
		{
			field: "workerTypeName",
			headerName: "Worker Type",
			sortable: true,
			flex: 1,
		},

		{
			field: "Actions",
			renderCell: (params) => {
				return (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						spacing={1}
						style={{ padding: "0" }}
					>
						<Grid item md={6} xs={6} style={{ padding: "0", marginLeft: -25 }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setWorkerTypeIdForEdit(params.row.workerTypeId);
										setModalEditDataWorkerType(true);
									})();
								}}
							>
								<EditIcon style={{ width: 16, height: 16 }} color="primary" />
							</Button>
						</Grid>
						<Grid item md={6} xs={6} style={{ padding: "0" }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setWorkerTypeIdForDelete(params.row.workerTypeId);
										setModalDeleteWorkerType(true);
									})();
								}}
							>
								<DeleteIcon
									style={{ width: 16, height: 16 }}
									color="secondary"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			headerName: " ",
			sortable: false,
		},
	];

	const rows = workerTypes.map(({ workerTypeId, workerTypeName }) => {
		return {
			workerTypeId,
			workerTypeName,
			id: workerTypeId,
		};
	});

	return { rows, columns };
};
